import React, { useEffect } from 'react'
import { MyDriveContainer } from './MyDrivePage.styled'
import { useStore } from '../../../../../../../../../hooks'
import { observer } from "mobx-react"
import DriveList from '../../components/DriveList/DriveList'
import DocumentList from '../../components/DocumentList/DocumentList'
import ErrorAlert from '../../components/ErrorAlert/ErrorAlert'

const MyDrivePage = observer(({ searchQuery = '' }) => {
	const { knowledgeStore, authStore } = useStore()

	useEffect(() => {
		const params = {
			tenant_id: "1",
			page: 1,
			page_size: 10,
			order_by: "created_at",
			order_direction: "desc"
		}
		knowledgeStore.vaultStore.fetchVaultList(params)
	}, [])

	const handleDriveClick = async (drive) => {
		try {
			console.log('drive', drive)
			knowledgeStore.setSelectedDrive(drive)
			const params = {
				vaultUuid: drive.vaultUuid,
				tenantId: "1"
			}
			await knowledgeStore.documentStore.fetchDocumentList(params)
		} catch (error) {
			console.error('Error fetching documents:', error)
		}
	}

	const handleDriveSelection = (vaultUuid) => {
		knowledgeStore.toggleDriveSelection(vaultUuid)
	}

	const handleDocumentSelection = (documentUuid) => {
		knowledgeStore.toggleDocumentSelection(documentUuid)
	}

	const handleClose = () => {
		knowledgeStore.vaultStore.isErrorLoadingVaults = false
		knowledgeStore.vaultStore.setIsErrorMessage('')
	}

	const handleCloseDocumentsError = () => {
		knowledgeStore.documentStore.isErrorLoadingDocuments = false
		knowledgeStore.documentStore.setIsDocumentsErrorMessage('')
	}

	const filteredDrives = knowledgeStore.vaultStore.vaultList?.data?.filter(vault =>
		!searchQuery ||
		vault.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
		(vault.description && vault.description.toLowerCase().includes(searchQuery.toLowerCase()))
	) || []

	const filteredDocuments = knowledgeStore.documentStore.documentList?.data?.filter(document =>
		!searchQuery ||
		document.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
		(document.description && document.description.toLowerCase().includes(searchQuery.toLowerCase()))
	) || []

	return (
		<MyDriveContainer>
			{knowledgeStore.isDocumentsView ? (
				<DocumentList
					documents={filteredDocuments}
					onDocumentSelection={handleDocumentSelection}
					selectedDocuments={knowledgeStore.selectedDocuments}
					isLoading={knowledgeStore.documentStore.isLoadingDocuments}
					searchQuery={searchQuery}
					selectedDriveTitle={knowledgeStore.selectedDriveTitle}
					selectedDriveOwner={knowledgeStore.selectedDrive.createdBy}
				/>
			) : (
				<DriveList
					drives={filteredDrives}
					onDriveClick={handleDriveClick}
					onDriveSelection={handleDriveSelection}
					selectedDrives={knowledgeStore.selectedDrives}
					isLoading={knowledgeStore.vaultStore.isLoadingVaults}
					searchQuery={searchQuery}
				/>
			)}

			{knowledgeStore.vaultStore.isErrorLoadingVaults && (
				<ErrorAlert
					message={knowledgeStore.vaultStore.isErrorMessage}
					onClose={handleClose}
				/>
			)}

			{knowledgeStore.documentStore.isErrorLoadingDocuments && (
				<ErrorAlert
					message={knowledgeStore.documentStore.isDocumentsErrorMessage}
					onClose={handleCloseDocumentsError}
				/>
			)}
		</MyDriveContainer>
	)
})

export default MyDrivePage